import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { usePortalAuth } from "./portalAuth";

export default function PortalAuthCallback() {
  const navigate = useNavigate();
  const { setUser } = usePortalAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/portal/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/portal/auth/session", { session_id });
        setUser(r.data);
        window.history.replaceState({}, "", "/portal/dashboard");
        navigate("/portal/dashboard", { replace: true });
      } catch (e) {
        console.error("Portal auth failed", e);
        const msg = e?.response?.data?.detail || "Access denied";
        navigate(`/portal/login?error=${encodeURIComponent(msg)}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-slate-50">
      <div className="flex items-center gap-3 text-slate-500">
        <div className="h-2 w-2 rounded-full bg-blue-600 pulse-dot" />
        <span className="font-mono text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
